import {Helmet, HelmetProvider} from '@dr.pogodin/react-helmet';
import {i18n} from '@online-offer/i18n';
import {Box, Center, Show, Space, Stack, VStack} from 'platform/foundation';

import {Route, Routes} from 'react-router-dom';

import {AdvertisementDescription} from './(sections)/AdvertisementDescription/AdvertisementDescription';
import {AdvertisementDescriptionPrint} from './(sections)/AdvertisementDescription/AdvertisementDescription.print';
import {Certificate} from './(sections)/Certificate/Certificate';
import {CertificatePrint} from './(sections)/Certificate/Certificate.print';
import {Details} from './(sections)/Details/Details';
import {DetailsPrint} from './(sections)/Details/Details.print';
import {Disclaimer} from './(sections)/Disclaimer/Disclaimer';
import {DisclaimerPrint} from './(sections)/Disclaimer/Disclaimer.print';
import {ElectricalParameters} from './(sections)/ElectricalParameters/ElectricalParameters';
import {ElectricalParametersPrint} from './(sections)/ElectricalParameters/ElectricalParameters.print';
import {ErrorSection} from './(sections)/ErrorSection/ErrorSection';
import {Features} from './(sections)/Features/Features';
import {FeaturesPrint} from './(sections)/Features/Features.print';
import {Hero} from './(sections)/Hero/Hero';
import {HeroPrint} from './(sections)/Hero/Hero.print';
import {ReservationCardPrint} from './(sections)/ReservationCard/ReservationCard.print';
import {SellerCard} from './(sections)/SellerCard/SellerCard';
import {SellerCardPrint} from './(sections)/SellerCard/SellerCard.print';
import {Sidebar} from './(sections)/Sidebar/Sidebar';
import {Specification} from './(sections)/Specification/Specification';
import {SpecificationPrint} from './(sections)/Specification/Specification.print';
import {TechnicalParameters} from './(sections)/TechnicalParameters/TechnicalParameters';
import {TechnicalParametersPrint} from './(sections)/TechnicalParameters/TechnicalParameters.print';
import {ApplicationInitializeBoundary} from './components/ApplicationInitializeBoundary/ApplicationInitializeBoundary';
import {Footer} from './components/Footer/Footer';
import {Navigation} from './components/Navigation/Navigation';
import {APPLICATION_NAME} from './consts/applicationName';

export function App() {
  return (
    <Routes>
      <Route element={<ApplicationInitializeBoundary />}>
        <Route path=":offerId/" element={<OnlineOffer />} />
        <Route path=":offerId/pdf" element={<OnlineOfferPrint />} />
        <Route path="*" element={<ErrorSection />} />
      </Route>
    </Routes>
  );
}

function OnlineOffer() {
  return (
    <HelmetProvider>
      <Helmet titleTemplate={`%s • ${APPLICATION_NAME}`} htmlAttributes={{lang: i18n.language}}>
        <meta name="description" content={APPLICATION_NAME} />
      </Helmet>

      <Navigation />

      <Hero />

      <Space vertical={[6, 6, 11]} />

      <Center>
        <Box flexGrow={1} paddingHorizontal={[3, 8, 20, 20]} maxWidth={440}>
          <Stack direction={['column-reverse', 'column-reverse', 'row']} spacing={8} width="100%">
            <VStack width="100%">
              <Specification />
              <Details />
              <ElectricalParameters />
              <AdvertisementDescription />
              <Features />
              <Certificate />
              <TechnicalParameters />
              <Show onMobile onTablet>
                <SellerCard />
              </Show>
              <Disclaimer />
            </VStack>
            <VStack spacing={[6, 6, 8]} width={['100%', '100%', 90]} shrink={0}>
              <Sidebar />
            </VStack>
          </Stack>
        </Box>
      </Center>
      <Footer />
    </HelmetProvider>
  );
}

function OnlineOfferPrint() {
  return (
    <HelmetProvider>
      <Helmet titleTemplate={`%s • ${APPLICATION_NAME}`} htmlAttributes={{lang: i18n.language}}>
        <meta name="description" content={APPLICATION_NAME} />
      </Helmet>

      <Box maxWidth={278} width={278} backgroundColor="fill.white">
        <HeroPrint />
        <SpecificationPrint />
        <DetailsPrint />
        <ElectricalParametersPrint />
        <AdvertisementDescriptionPrint />
        <FeaturesPrint />
        <CertificatePrint />
        <TechnicalParametersPrint />
        <ReservationCardPrint />
        <SellerCardPrint />
        <DisclaimerPrint />
      </Box>
    </HelmetProvider>
  );
}
